import IntersectionCheck from './Timetable/IntersectionCheck';
import AddVideoLesson from './AddVideoLesson';
import RemoveVideoLesson from './RemoveVideoLesson';
import BulkUpload from './BulkUpload';
import AddLessonOrMeeting from './Timetable/AddLessonOrMeeting';
import { actions } from '@pages/Main/Timetable/actionsEnum';
import JournalDownloadExcel from './Journal/JournalDownloadExcel';
import JournalAddField from './Journal/JournalAddField';
import TYPES from './TYPES';
import EditLessonOrMeeting from './Timetable/EditLessonOrMeeting';
import ShowLessonOrMeeting from './Timetable/ShowLessonOrMeeting';
import JournalAddColumn from './Journal/JournalAddColumn';
import Confirmation from './Confirmation';
import { UploadMediaModal } from './PlatformMedia/UploadMediaModal/UploadMediaModal';
import CopyMaterial from './EditDirection/CopyMaterial';
import ResizeImage from './tiptap/ResizeImage';

const modalsList = [
    {
        name: 'addVideoLesson',
        component: AddVideoLesson
    },
    {
        name: 'removeVideoLesson',
        component: RemoveVideoLesson
    },
    {
        name: 'bulkUpload',
        component: BulkUpload
    },
    {
        name: actions.addLessonOrMeeting,
        component: AddLessonOrMeeting
    },
    {
        name: actions.intersectionCheck,
        component: IntersectionCheck
    },
    {
        name: TYPES.JOURNAL_ADD_FIELD,
        component: JournalAddField
    },
    {
        name: TYPES.JOURNAL_ADD_COLUMN,
        component: JournalAddColumn
    },
    {
        name: TYPES.JOURNAL_DOWNLOAD_EXCEL,
        component: JournalDownloadExcel
    },
    {
        name: actions.showLessonOrMeeting,
        component: ShowLessonOrMeeting
    },
    {
        name: actions.editLessonOrMeeting,
        component: EditLessonOrMeeting
    },
    {
        name: TYPES.CONFIRMATION,
        component: Confirmation
    },
    {
        name: TYPES.UPLOADING_FILES_TO_MEDIA_PLATFORMS,
        component: UploadMediaModal
    },
    {
        name: TYPES.EDIT_DIRECTION_COPY,
        component: CopyMaterial
    },
    {
        name: TYPES.TIPTAP_RESIZE_IMAGE,
        component: ResizeImage
    },
];

export default modalsList;